import { Component } from '@angular/core';

@Component({
	selector: 'app-legal',
	templateUrl: './legal.component.html',
	standalone: false,
})
export class LegalComponent {}
